export default "__VITE_ASSET__CTpgeEtN__"